import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { createFileRoute } from '@tanstack/react-router'

import { IconGtoWizardLogoSigned } from '@gto/ui/assets'
import { Button } from '@gto/ui/button'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { buildOAuthRedirectUrl } from '@/utils/oauth'

export const Route = createFileRoute('/_auth/login/')({
  component: LoginRedirect,
})

// Kicked off in useEffect (not beforeLoad) so the async PKCE work in
// buildOAuthRedirectUrl runs after mount and the manual CTA below remains
// reachable if crypto.subtle.digest stalls or window.location.href fails.
function LoginRedirect() {
  const goToOAuth = () => {
    void buildOAuthRedirectUrl().then((url) => {
      window.location.href = url
    })
  }

  useEffect(function triggerOAuthRedirectOnMount() {
    goToOAuth()
  }, [])

  return (
    <div className="flex h-[100dvh] items-center justify-center overflow-hidden bg-gradient-primary-vertical p-6">
      <Paper
        className="w-full max-w-[420px] rounded-lg p-8 sm:p-6"
        variant="outlined"
      >
        <div className="flex flex-col gap-8">
          <IconGtoWizardLogoSigned style={{ height: 24, width: 'auto' }} />

          <div className="flex flex-col gap-2">
            <Typography
              className="font-semibold"
              color="text.primary"
              variant="h5"
            >
              <FormattedMessage id="auth.login.redirecting" />
            </Typography>
            <Typography
              color="text.secondary"
              variant="body2"
            >
              <FormattedMessage id="auth.login.redirectingDescription" />
            </Typography>
          </div>

          <Button
            fullWidth
            color="primary"
            variant="contained"
            onClick={goToOAuth}
          >
            <FormattedMessage id="auth.login.cta" />
          </Button>
        </div>
      </Paper>
    </div>
  )
}
